// extracted by mini-css-extract-plugin
export default {"div":"OnboardingForm_div__pqH-h","in":"OnboardingForm_in__Wiyoq"};